import { motion, useInView, animate } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import { EASE } from '../data/site';

const MaskedLine = ({ children, delay, lineClassName, onLoad }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-5% 0px' });
  return (
    <span ref={ref} className="block overflow-hidden pb-[0.14em] -mb-[0.14em]">
      <motion.span
        className={`block will-change-transform ${lineClassName}`}
        initial={{ y: '115%' }}
        animate={onLoad || inView ? { y: 0 } : {}}
        transition={{ duration: 1, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
};

export const MaskedLines = ({ lines, className = '', lineClassName = '', delay = 0, onLoad = false }) => (
  <span className={`block ${className}`}>
    {lines.map((l, i) => (
      <MaskedLine key={i} delay={delay + i * 0.11} lineClassName={lineClassName} onLoad={onLoad}>
        {l}
      </MaskedLine>
    ))}
  </span>
);

export const FadeUp = ({ children, delay = 0, y = 36, className = '' }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-10% 0px' }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Counter = ({ to, format = (v) => Math.round(v).toLocaleString('en-IN'), className = '' }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-15% 0px' });
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 2.2,
      ease: EASE,
      onUpdate: (v) => setVal(v),
    });
    return () => controls.stop();
  }, [inView, to]);
  return (
    <span ref={ref} className={className}>
      {format(val)}
    </span>
  );
};

export const Eyebrow = ({ children, color = '#B50A00', className = '' }) => (
  <FadeUp y={16} className={`flex items-center gap-3 ${className}`}>
    <span className="h-2 w-2 rounded-full" style={{ background: color }} />
    <span className="text-xs md:text-sm font-semibold uppercase tracking-[0.25em]" style={{ color }}>
      {children}
    </span>
  </FadeUp>
);
